// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Debono Design System v1.1
 *
 * Glassmorphism + High Contrast Dark Theme
 * Font: Outfit (geometric, bold, great for ALL CAPS)
 */

:root {
  /* ============================================
     TYPOGRAPHY
     ============================================ */
  --font-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  --font-display: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-serif: 'Instrument Serif', 'Times New Roman', Georgia, serif;
  --font-mono: 'JetBrains Mono', 'SF Mono', Menlo, Monaco, Consolas, monospace;

  /* Font weights */
  --font-weight-regular: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  --font-weight-black: 900;

  /* Font sizes */
  --text-xs: 0.65rem;    /* 10.4px - micro labels */
  --text-sm: 0.75rem;    /* 12px - small labels, tags */
  --text-base: 0.875rem; /* 14px - body text */
  --text-md: 1rem;       /* 16px - default */
  --text-lg: 1.125rem;   /* 18px - emphasis */
  --text-xl: 1.25rem;    /* 20px - subheadings */
  --text-2xl: 1.5rem;    /* 24px - section headers */
  --text-3xl: 2rem;      /* 32px - page titles */
  --text-4xl: 2.5rem;    /* 40px - hero text */

  /* Line heights */
  --leading-tight: 1.2;
  --leading-normal: 1.5;
  --leading-relaxed: 1.6;

  /* Letter spacing */
  --tracking-tight: -0.02em;
  --tracking-normal: 0;
  --tracking-wide: 0.05em;
  --tracking-wider: 0.08em;
  --tracking-widest: 0.1em;

  /* ============================================
     COLORS - BACKGROUNDS
     ============================================ */
  --bg-base: #0a0a0a;
  --bg-elevated: #111111;
  --bg-surface: rgba(255, 255, 255, 0.02);
  --bg-surface-hover: rgba(255, 255, 255, 0.04);
  --bg-surface-active: rgba(255, 255, 255, 0.06);
  --bg-card: rgba(255, 255, 255, 0.03);
  --bg-card-hover: rgba(255, 255, 255, 0.05);
  --bg-input: rgba(255, 255, 255, 0.05);
  --bg-input-focus: rgba(255, 255, 255, 0.08);

  /* ============================================
     COLORS - TEXT
     ============================================ */
  --text-primary: #ffffff;
  --text-secondary: #d1d5db;
  --text-muted: #9ca3af;
  --text-subtle: #6b7280;
  --text-disabled: #4b5563;

  /* ============================================
     COLORS - BORDERS
     ============================================ */
  --border-subtle: rgba(255, 255, 255, 0.06);
  --border-default: rgba(255, 255, 255, 0.1);
  --border-strong: rgba(255, 255, 255, 0.15);
  --border-focus: rgba(255, 255, 255, 0.25);

  /* ============================================
     COLORS - ACCENT (Primary = Red)
     ============================================ */
  --accent-primary: #ef4444;
  --accent-primary-hover: #dc2626;
  --accent-primary-muted: rgba(239, 68, 68, 0.15);
  --accent-primary-border: rgba(239, 68, 68, 0.3);

  /* ============================================
     COLORS - SEMANTIC (Content Type Tags)
     ============================================ */
  /* Physiology - Green */
  --color-physiology: #22c55e;
  --color-physiology-bg: rgba(34, 197, 94, 0.15);
  --color-physiology-border: rgba(34, 197, 94, 0.3);

  /* Pathophysiology - Red */
  --color-pathophysiology: #ef4444;
  --color-pathophysiology-bg: rgba(239, 68, 68, 0.15);
  --color-pathophysiology-border: rgba(239, 68, 68, 0.3);

  /* Etiology - Purple */
  --color-etiology: #8b5cf6;
  --color-etiology-bg: rgba(139, 92, 246, 0.15);
  --color-etiology-border: rgba(139, 92, 246, 0.3);

  /* Diagnosis - Sky Blue */
  --color-diagnosis: #0ea5e9;
  --color-diagnosis-bg: rgba(14, 165, 233, 0.15);
  --color-diagnosis-border: rgba(14, 165, 233, 0.3);

  /* Treatment - Teal */
  --color-treatment: #14b8a6;
  --color-treatment-bg: rgba(20, 184, 166, 0.15);
  --color-treatment-border: rgba(20, 184, 166, 0.3);

  /* Drug Info - Amber */
  --color-drug-info: #f59e0b;
  --color-drug-info-bg: rgba(245, 158, 11, 0.15);
  --color-drug-info-border: rgba(245, 158, 11, 0.3);

  /* ============================================
     COLORS - STATUS
     ============================================ */
  --color-success: #22c55e;
  --color-success-bg: rgba(34, 197, 94, 0.15);
  --color-warning: #f59e0b;
  --color-warning-bg: rgba(245, 158, 11, 0.15);
  --color-error: #ef4444;
  --color-error-bg: rgba(239, 68, 68, 0.15);
  --color-info: #0ea5e9;
  --color-info-bg: rgba(14, 165, 233, 0.15);

  /* ============================================
     SPACING
     ============================================ */
  --space-1: 0.25rem;  /* 4px */
  --space-2: 0.5rem;   /* 8px */
  --space-3: 0.75rem;  /* 12px */
  --space-4: 1rem;     /* 16px */
  --space-5: 1.25rem;  /* 20px */
  --space-6: 1.5rem;   /* 24px */
  --space-8: 2rem;     /* 32px */
  --space-10: 2.5rem;  /* 40px */
  --space-12: 3rem;    /* 48px */
  --space-16: 4rem;    /* 64px */

  /* ============================================
     BORDER RADIUS
     ============================================ */
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-2xl: 16px;
  --radius-full: 9999px;

  /* ============================================
     SHADOWS & EFFECTS
     ============================================ */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);
  --shadow-glow: 0 0 20px rgba(239, 68, 68, 0.3);

  /* Glassmorphism */
  --glass-blur: blur(10px);
  --glass-blur-strong: blur(20px);

  /* ============================================
     LAYOUT — Shared Question/Activity Container
     ============================================ */
  --container-content: min(94vw, 68rem);   /* ~1088px — general content (slides, teaching blocks, nav bars) */
  --container-question: min(92vw, 52rem);  /* ~832px  — single-column questions/drills for readability   */

  /* ============================================
     TRANSITIONS
     ============================================ */
  --transition-fast: 150ms ease;
  --transition-normal: 200ms ease;
  --transition-slow: 300ms ease;

  /* ============================================
     Z-INDEX LAYERS
     ============================================ */
  --z-base: 0;
  --z-dropdown: 100;
  --z-sticky: 200;
  --z-modal-backdrop: 300;
  --z-modal: 400;
  --z-toast: 500;
  --z-tooltip: 600;
  --z-fab: 900;
}

/* ============================================
   UTILITY CLASSES
   ============================================ */

/* Glassmorphism card */
.glass-card {
  background: var(--bg-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-2xl);
  backdrop-filter: var(--glass-blur);
}

.glass-card:hover {
  background: var(--bg-card-hover);
  border-color: var(--border-strong);
}

/* ALL CAPS label style */
.caps-label {
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--tracking-widest);
  text-transform: uppercase;
  color: var(--text-subtle);
}

/* Tag base style */
.tag {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
}

/* Tag color variants */
.tag-physiology {
  background: var(--color-physiology-bg);
  border: 1px solid var(--color-physiology-border);
  color: var(--color-physiology);
}

.tag-pathophysiology {
  background: var(--color-pathophysiology-bg);
  border: 1px solid var(--color-pathophysiology-border);
  color: var(--color-pathophysiology);
}

.tag-etiology {
  background: var(--color-etiology-bg);
  border: 1px solid var(--color-etiology-border);
  color: var(--color-etiology);
}

.tag-diagnosis {
  background: var(--color-diagnosis-bg);
  border: 1px solid var(--color-diagnosis-border);
  color: var(--color-diagnosis);
}

.tag-treatment {
  background: var(--color-treatment-bg);
  border: 1px solid var(--color-treatment-border);
  color: var(--color-treatment);
}

.tag-drug-info {
  background: var(--color-drug-info-bg);
  border: 1px solid var(--color-drug-info-border);
  color: var(--color-drug-info);
}

/* Button styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: 0.6rem 1.25rem;
  border-radius: var(--radius-lg);
  font-family: var(--font-primary);
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
}

.btn-primary {
  background: var(--accent-primary);
  color: var(--text-primary);
}

.btn-primary:hover {
  background: var(--accent-primary-hover);
}

.btn-secondary {
  background: var(--bg-surface);
  border: 1px solid var(--border-strong);
  color: var(--text-secondary);
}

.btn-secondary:hover {
  background: var(--bg-surface-hover);
  border-color: var(--border-focus);
  color: var(--text-primary);
}

.btn-ghost {
  background: transparent;
  color: var(--text-muted);
}

.btn-ghost:hover {
  background: var(--bg-surface);
  color: var(--text-primary);
}

/* ============================================
   BACKGROUND PRESETS — user-controlled (Settings → Appearance)
   ============================================
   Applied to <html data-bg-preset="..."> by UISettingsContext.
   Each preset re-declares bg/border tokens so one anchor shifts
   all layered surfaces in lockstep (boundary consistency).
   Text + accent tokens stay fixed across all presets. */

html[data-bg-preset="void"] {
  --bg-base: #0a0a0a;
}

html[data-bg-preset="carbon"] {
  --bg-base: #1d1d20;
}

html[data-bg-preset="neutral"] {
  --bg-base: #262626;
  --bg-elevated: #303030;
  --bg-surface: rgba(255, 255, 255, 0.05);
  --bg-surface-hover: rgba(255, 255, 255, 0.08);
  --bg-surface-active: rgba(255, 255, 255, 0.12);
  --bg-card: rgba(255, 255, 255, 0.06);
  --bg-card-hover: rgba(255, 255, 255, 0.1);
  --bg-input: rgba(255, 255, 255, 0.09);
  --bg-input-focus: rgba(255, 255, 255, 0.14);
  --border-subtle: rgba(255, 255, 255, 0.1);
  --border-default: rgba(255, 255, 255, 0.16);
  --border-strong: rgba(255, 255, 255, 0.24);
  --border-focus: rgba(255, 255, 255, 0.35);
}

html[data-bg-preset="warm"] {
  --bg-base: #383838;
  --bg-elevated: #424242;
  --bg-surface: rgba(255, 255, 255, 0.06);
  --bg-surface-hover: rgba(255, 255, 255, 0.1);
  --bg-surface-active: rgba(255, 255, 255, 0.15);
  --bg-card: rgba(255, 255, 255, 0.07);
  --bg-card-hover: rgba(255, 255, 255, 0.12);
  --bg-input: rgba(255, 255, 255, 0.11);
  --bg-input-focus: rgba(255, 255, 255, 0.16);
  --border-subtle: rgba(255, 255, 255, 0.12);
  --border-default: rgba(255, 255, 255, 0.2);
  --border-strong: rgba(255, 255, 255, 0.3);
  --border-focus: rgba(255, 255, 255, 0.4);
}

html[data-bg-preset="soft"] {
  --bg-base: #4d4d4d;
  --bg-elevated: #575757;
  --bg-surface: rgba(255, 255, 255, 0.08);
  --bg-surface-hover: rgba(255, 255, 255, 0.12);
  --bg-surface-active: rgba(255, 255, 255, 0.17);
  --bg-card: rgba(255, 255, 255, 0.09);
  --bg-card-hover: rgba(255, 255, 255, 0.14);
  --bg-input: rgba(255, 255, 255, 0.13);
  --bg-input-focus: rgba(255, 255, 255, 0.19);
  --border-subtle: rgba(255, 255, 255, 0.14);
  --border-default: rgba(255, 255, 255, 0.24);
  --border-strong: rgba(255, 255, 255, 0.36);
  --border-focus: rgba(255, 255, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-tokens.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE;;mDAEiD;EACjD,4GAA4G;EAC5G,mFAAmF;EACnF,mEAAmE;EACnE,4EAA4E;;EAE5E,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;;EAExB,eAAe;EACf,kBAAkB,KAAK,0BAA0B;EACjD,kBAAkB,KAAK,8BAA8B;EACrD,qBAAqB,EAAE,qBAAqB;EAC5C,eAAe,QAAQ,mBAAmB;EAC1C,mBAAmB,IAAI,oBAAoB;EAC3C,kBAAkB,KAAK,uBAAuB;EAC9C,kBAAkB,KAAK,2BAA2B;EAClD,gBAAgB,OAAO,uBAAuB;EAC9C,kBAAkB,KAAK,qBAAqB;;EAE5C,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;;EAEtB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;;EAExB;;mDAEiD;EACjD,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,6CAA6C;EAC7C,8CAA8C;EAC9C,oCAAoC;EACpC,0CAA0C;EAC1C,qCAAqC;EACrC,2CAA2C;;EAE3C;;mDAEiD;EACjD,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;;EAExB;;mDAEiD;EACjD,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,yCAAyC;;EAEzC;;mDAEiD;EACjD,yBAAyB;EACzB,+BAA+B;EAC/B,+CAA+C;EAC/C,+CAA+C;;EAE/C;;mDAEiD;EACjD,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;EAC9C,iDAAiD;;EAEjD,0BAA0B;EAC1B,gCAAgC;EAChC,mDAAmD;EACnD,sDAAsD;;EAEtD,sBAAsB;EACtB,yBAAyB;EACzB,6CAA6C;EAC7C,gDAAgD;;EAEhD,yBAAyB;EACzB,0BAA0B;EAC1B,8CAA8C;EAC9C,iDAAiD;;EAEjD,qBAAqB;EACrB,0BAA0B;EAC1B,8CAA8C;EAC9C,iDAAiD;;EAEjD,sBAAsB;EACtB,0BAA0B;EAC1B,8CAA8C;EAC9C,iDAAiD;;EAEjD;;mDAEiD;EACjD,wBAAwB;EACxB,2CAA2C;EAC3C,wBAAwB;EACxB,4CAA4C;EAC5C,sBAAsB;EACtB,yCAAyC;EACzC,qBAAqB;EACrB,yCAAyC;;EAEzC;;mDAEiD;EACjD,kBAAkB,GAAG,QAAQ;EAC7B,iBAAiB,IAAI,QAAQ;EAC7B,kBAAkB,GAAG,SAAS;EAC9B,eAAe,MAAM,SAAS;EAC9B,kBAAkB,GAAG,SAAS;EAC9B,iBAAiB,IAAI,SAAS;EAC9B,eAAe,MAAM,SAAS;EAC9B,kBAAkB,GAAG,SAAS;EAC9B,gBAAgB,KAAK,SAAS;EAC9B,gBAAgB,KAAK,SAAS;;EAE9B;;mDAEiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;;EAErB;;mDAEiD;EACjD,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;EAC3C,8CAA8C;;EAE9C,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;;EAE/B;;mDAEiD;EACjD,qCAAqC,IAAI,kEAAkE;EAC3G,sCAAsC,GAAG,+DAA+D;;EAExG;;mDAEiD;EACjD,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;;EAE7B;;mDAEiD;EACjD,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,wCAAwC;EACxC,sCAAsC;EACtC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,sCAAsC;EACtC,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;;;;;wDAMwD;;AAExD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,6CAA6C;EAC7C,8CAA8C;EAC9C,oCAAoC;EACpC,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,4CAA4C;EAC5C,8CAA8C;EAC9C,oCAAoC;EACpC,0CAA0C;EAC1C,qCAAqC;EACrC,2CAA2C;EAC3C,0CAA0C;EAC1C,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,6CAA6C;EAC7C,8CAA8C;EAC9C,oCAAoC;EACpC,0CAA0C;EAC1C,qCAAqC;EACrC,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,0CAA0C;EAC1C,wCAAwC;AAC1C","sourcesContent":["/**\n * Debono Design System v1.1\n *\n * Glassmorphism + High Contrast Dark Theme\n * Font: Outfit (geometric, bold, great for ALL CAPS)\n */\n\n:root {\n  /* ============================================\n     TYPOGRAPHY\n     ============================================ */\n  --font-primary: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n  --font-display: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  --font-serif: 'Instrument Serif', 'Times New Roman', Georgia, serif;\n  --font-mono: 'JetBrains Mono', 'SF Mono', Menlo, Monaco, Consolas, monospace;\n\n  /* Font weights */\n  --font-weight-regular: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n  --font-weight-black: 900;\n\n  /* Font sizes */\n  --text-xs: 0.65rem;    /* 10.4px - micro labels */\n  --text-sm: 0.75rem;    /* 12px - small labels, tags */\n  --text-base: 0.875rem; /* 14px - body text */\n  --text-md: 1rem;       /* 16px - default */\n  --text-lg: 1.125rem;   /* 18px - emphasis */\n  --text-xl: 1.25rem;    /* 20px - subheadings */\n  --text-2xl: 1.5rem;    /* 24px - section headers */\n  --text-3xl: 2rem;      /* 32px - page titles */\n  --text-4xl: 2.5rem;    /* 40px - hero text */\n\n  /* Line heights */\n  --leading-tight: 1.2;\n  --leading-normal: 1.5;\n  --leading-relaxed: 1.6;\n\n  /* Letter spacing */\n  --tracking-tight: -0.02em;\n  --tracking-normal: 0;\n  --tracking-wide: 0.05em;\n  --tracking-wider: 0.08em;\n  --tracking-widest: 0.1em;\n\n  /* ============================================\n     COLORS - BACKGROUNDS\n     ============================================ */\n  --bg-base: #0a0a0a;\n  --bg-elevated: #111111;\n  --bg-surface: rgba(255, 255, 255, 0.02);\n  --bg-surface-hover: rgba(255, 255, 255, 0.04);\n  --bg-surface-active: rgba(255, 255, 255, 0.06);\n  --bg-card: rgba(255, 255, 255, 0.03);\n  --bg-card-hover: rgba(255, 255, 255, 0.05);\n  --bg-input: rgba(255, 255, 255, 0.05);\n  --bg-input-focus: rgba(255, 255, 255, 0.08);\n\n  /* ============================================\n     COLORS - TEXT\n     ============================================ */\n  --text-primary: #ffffff;\n  --text-secondary: #d1d5db;\n  --text-muted: #9ca3af;\n  --text-subtle: #6b7280;\n  --text-disabled: #4b5563;\n\n  /* ============================================\n     COLORS - BORDERS\n     ============================================ */\n  --border-subtle: rgba(255, 255, 255, 0.06);\n  --border-default: rgba(255, 255, 255, 0.1);\n  --border-strong: rgba(255, 255, 255, 0.15);\n  --border-focus: rgba(255, 255, 255, 0.25);\n\n  /* ============================================\n     COLORS - ACCENT (Primary = Red)\n     ============================================ */\n  --accent-primary: #ef4444;\n  --accent-primary-hover: #dc2626;\n  --accent-primary-muted: rgba(239, 68, 68, 0.15);\n  --accent-primary-border: rgba(239, 68, 68, 0.3);\n\n  /* ============================================\n     COLORS - SEMANTIC (Content Type Tags)\n     ============================================ */\n  /* Physiology - Green */\n  --color-physiology: #22c55e;\n  --color-physiology-bg: rgba(34, 197, 94, 0.15);\n  --color-physiology-border: rgba(34, 197, 94, 0.3);\n\n  /* Pathophysiology - Red */\n  --color-pathophysiology: #ef4444;\n  --color-pathophysiology-bg: rgba(239, 68, 68, 0.15);\n  --color-pathophysiology-border: rgba(239, 68, 68, 0.3);\n\n  /* Etiology - Purple */\n  --color-etiology: #8b5cf6;\n  --color-etiology-bg: rgba(139, 92, 246, 0.15);\n  --color-etiology-border: rgba(139, 92, 246, 0.3);\n\n  /* Diagnosis - Sky Blue */\n  --color-diagnosis: #0ea5e9;\n  --color-diagnosis-bg: rgba(14, 165, 233, 0.15);\n  --color-diagnosis-border: rgba(14, 165, 233, 0.3);\n\n  /* Treatment - Teal */\n  --color-treatment: #14b8a6;\n  --color-treatment-bg: rgba(20, 184, 166, 0.15);\n  --color-treatment-border: rgba(20, 184, 166, 0.3);\n\n  /* Drug Info - Amber */\n  --color-drug-info: #f59e0b;\n  --color-drug-info-bg: rgba(245, 158, 11, 0.15);\n  --color-drug-info-border: rgba(245, 158, 11, 0.3);\n\n  /* ============================================\n     COLORS - STATUS\n     ============================================ */\n  --color-success: #22c55e;\n  --color-success-bg: rgba(34, 197, 94, 0.15);\n  --color-warning: #f59e0b;\n  --color-warning-bg: rgba(245, 158, 11, 0.15);\n  --color-error: #ef4444;\n  --color-error-bg: rgba(239, 68, 68, 0.15);\n  --color-info: #0ea5e9;\n  --color-info-bg: rgba(14, 165, 233, 0.15);\n\n  /* ============================================\n     SPACING\n     ============================================ */\n  --space-1: 0.25rem;  /* 4px */\n  --space-2: 0.5rem;   /* 8px */\n  --space-3: 0.75rem;  /* 12px */\n  --space-4: 1rem;     /* 16px */\n  --space-5: 1.25rem;  /* 20px */\n  --space-6: 1.5rem;   /* 24px */\n  --space-8: 2rem;     /* 32px */\n  --space-10: 2.5rem;  /* 40px */\n  --space-12: 3rem;    /* 48px */\n  --space-16: 4rem;    /* 64px */\n\n  /* ============================================\n     BORDER RADIUS\n     ============================================ */\n  --radius-sm: 4px;\n  --radius-md: 6px;\n  --radius-lg: 8px;\n  --radius-xl: 12px;\n  --radius-2xl: 16px;\n  --radius-full: 9999px;\n\n  /* ============================================\n     SHADOWS & EFFECTS\n     ============================================ */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.5);\n  --shadow-glow: 0 0 20px rgba(239, 68, 68, 0.3);\n\n  /* Glassmorphism */\n  --glass-blur: blur(10px);\n  --glass-blur-strong: blur(20px);\n\n  /* ============================================\n     LAYOUT — Shared Question/Activity Container\n     ============================================ */\n  --container-content: min(94vw, 68rem);   /* ~1088px — general content (slides, teaching blocks, nav bars) */\n  --container-question: min(92vw, 52rem);  /* ~832px  — single-column questions/drills for readability   */\n\n  /* ============================================\n     TRANSITIONS\n     ============================================ */\n  --transition-fast: 150ms ease;\n  --transition-normal: 200ms ease;\n  --transition-slow: 300ms ease;\n\n  /* ============================================\n     Z-INDEX LAYERS\n     ============================================ */\n  --z-base: 0;\n  --z-dropdown: 100;\n  --z-sticky: 200;\n  --z-modal-backdrop: 300;\n  --z-modal: 400;\n  --z-toast: 500;\n  --z-tooltip: 600;\n  --z-fab: 900;\n}\n\n/* ============================================\n   UTILITY CLASSES\n   ============================================ */\n\n/* Glassmorphism card */\n.glass-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-2xl);\n  backdrop-filter: var(--glass-blur);\n}\n\n.glass-card:hover {\n  background: var(--bg-card-hover);\n  border-color: var(--border-strong);\n}\n\n/* ALL CAPS label style */\n.caps-label {\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--tracking-widest);\n  text-transform: uppercase;\n  color: var(--text-subtle);\n}\n\n/* Tag base style */\n.tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.35rem 0.75rem;\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--tracking-wide);\n  text-transform: uppercase;\n}\n\n/* Tag color variants */\n.tag-physiology {\n  background: var(--color-physiology-bg);\n  border: 1px solid var(--color-physiology-border);\n  color: var(--color-physiology);\n}\n\n.tag-pathophysiology {\n  background: var(--color-pathophysiology-bg);\n  border: 1px solid var(--color-pathophysiology-border);\n  color: var(--color-pathophysiology);\n}\n\n.tag-etiology {\n  background: var(--color-etiology-bg);\n  border: 1px solid var(--color-etiology-border);\n  color: var(--color-etiology);\n}\n\n.tag-diagnosis {\n  background: var(--color-diagnosis-bg);\n  border: 1px solid var(--color-diagnosis-border);\n  color: var(--color-diagnosis);\n}\n\n.tag-treatment {\n  background: var(--color-treatment-bg);\n  border: 1px solid var(--color-treatment-border);\n  color: var(--color-treatment);\n}\n\n.tag-drug-info {\n  background: var(--color-drug-info-bg);\n  border: 1px solid var(--color-drug-info-border);\n  color: var(--color-drug-info);\n}\n\n/* Button styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: 0.6rem 1.25rem;\n  border-radius: var(--radius-lg);\n  font-family: var(--font-primary);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n}\n\n.btn-primary {\n  background: var(--accent-primary);\n  color: var(--text-primary);\n}\n\n.btn-primary:hover {\n  background: var(--accent-primary-hover);\n}\n\n.btn-secondary {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-strong);\n  color: var(--text-secondary);\n}\n\n.btn-secondary:hover {\n  background: var(--bg-surface-hover);\n  border-color: var(--border-focus);\n  color: var(--text-primary);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text-muted);\n}\n\n.btn-ghost:hover {\n  background: var(--bg-surface);\n  color: var(--text-primary);\n}\n\n/* ============================================\n   BACKGROUND PRESETS — user-controlled (Settings → Appearance)\n   ============================================\n   Applied to <html data-bg-preset=\"...\"> by UISettingsContext.\n   Each preset re-declares bg/border tokens so one anchor shifts\n   all layered surfaces in lockstep (boundary consistency).\n   Text + accent tokens stay fixed across all presets. */\n\nhtml[data-bg-preset=\"void\"] {\n  --bg-base: #0a0a0a;\n}\n\nhtml[data-bg-preset=\"carbon\"] {\n  --bg-base: #1d1d20;\n}\n\nhtml[data-bg-preset=\"neutral\"] {\n  --bg-base: #262626;\n  --bg-elevated: #303030;\n  --bg-surface: rgba(255, 255, 255, 0.05);\n  --bg-surface-hover: rgba(255, 255, 255, 0.08);\n  --bg-surface-active: rgba(255, 255, 255, 0.12);\n  --bg-card: rgba(255, 255, 255, 0.06);\n  --bg-card-hover: rgba(255, 255, 255, 0.1);\n  --bg-input: rgba(255, 255, 255, 0.09);\n  --bg-input-focus: rgba(255, 255, 255, 0.14);\n  --border-subtle: rgba(255, 255, 255, 0.1);\n  --border-default: rgba(255, 255, 255, 0.16);\n  --border-strong: rgba(255, 255, 255, 0.24);\n  --border-focus: rgba(255, 255, 255, 0.35);\n}\n\nhtml[data-bg-preset=\"warm\"] {\n  --bg-base: #383838;\n  --bg-elevated: #424242;\n  --bg-surface: rgba(255, 255, 255, 0.06);\n  --bg-surface-hover: rgba(255, 255, 255, 0.1);\n  --bg-surface-active: rgba(255, 255, 255, 0.15);\n  --bg-card: rgba(255, 255, 255, 0.07);\n  --bg-card-hover: rgba(255, 255, 255, 0.12);\n  --bg-input: rgba(255, 255, 255, 0.11);\n  --bg-input-focus: rgba(255, 255, 255, 0.16);\n  --border-subtle: rgba(255, 255, 255, 0.12);\n  --border-default: rgba(255, 255, 255, 0.2);\n  --border-strong: rgba(255, 255, 255, 0.3);\n  --border-focus: rgba(255, 255, 255, 0.4);\n}\n\nhtml[data-bg-preset=\"soft\"] {\n  --bg-base: #4d4d4d;\n  --bg-elevated: #575757;\n  --bg-surface: rgba(255, 255, 255, 0.08);\n  --bg-surface-hover: rgba(255, 255, 255, 0.12);\n  --bg-surface-active: rgba(255, 255, 255, 0.17);\n  --bg-card: rgba(255, 255, 255, 0.09);\n  --bg-card-hover: rgba(255, 255, 255, 0.14);\n  --bg-input: rgba(255, 255, 255, 0.13);\n  --bg-input-focus: rgba(255, 255, 255, 0.19);\n  --border-subtle: rgba(255, 255, 255, 0.14);\n  --border-default: rgba(255, 255, 255, 0.24);\n  --border-strong: rgba(255, 255, 255, 0.36);\n  --border-focus: rgba(255, 255, 255, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
